import { render, staticRenderFns } from "./GamePayments.vue?vue&type=template&id=272bf050&scoped=true"
import script from "./GamePayments.vue?vue&type=script&lang=js"
export * from "./GamePayments.vue?vue&type=script&lang=js"
import style0 from "./GamePayments.vue?vue&type=style&index=0&id=272bf050&prod&scoped=true&lang=css"
import style1 from "./GamePayments.vue?vue&type=style&index=1&id=272bf050&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272bf050",
  null
  
)

export default component.exports